/* Copyright (c) 2026 Xperi. All Rights Reserved. */

enum VisibilityState {
  FOREGROUND = "FOREGROUND",
  BACKGROUND = "BACKGROUND"
}

export default VisibilityState;
